






















import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import SecondaryWalletTypeSettingsRead from '@/components/Accounts/DepositAccounts/Wallets/SecondaryWallets/WalletType/SecondaryWalletTypeSettingsRead.vue';
import SecondaryWalletInterestSettingsRead from '@/components/Accounts/DepositAccounts/Wallets/SecondaryWallets/WalletInterest/SecondaryWalletInterestSettingsRead.vue';

@Component({ name: 'SecondaryWalletsSettings', components: { SecondaryWalletTypeSettingsRead, SecondaryWalletInterestSettingsRead } })
export default class extends SaascadaVue {

    tabIndex = 0;

    get isInterestSettingsAvailable() {
        return DepositAccountModule.currentDepositAccountWallet.walletSettings?.depositInterestSettings;
    }

}
